import { call, put, select } from 'redux-saga/effects';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { selectCallIngestion } from '../../../state/config/configSlice';
import { backendClient } from '../../../services/api/backend-client';
import bugsnagClient from '../../../services/bugsnag/bugsnag';

export function* processCallRecordingSaga(action) {
  const { callId, callNumber, callType, callDuration } = action.payload;
  const { uid, domain, analyticsProcessingEnabled } = yield select(selectUserCredentials);
  const callIngestion = yield select(selectCallIngestion);
  
  if (!analyticsProcessingEnabled) {
    console.log(`Analytics disabled - skipping call ${callId} processing.`);
    return;
  }

  // Webhook domains are processed from the PBX webhook
  if (callIngestion === 'webhook') {
    console.log(`Call ingestion is webhook - skipping call ${callId} processing.`);
    return;
  }

  try {
    const params = {
      callId,
      callNumber,
      callType,
      domain,
      uid,
      duration: String(callDuration),
    };

    yield call(
      backendClient.post,
      'calls/process',
      null,
      { params }
    );

    console.log(`✅ Call ${callId} enqueued for analysis.`);
  } catch (err) {
    bugsnagClient.notify(err);
    console.error(`Error enqueueing call ${callId}:`, err);
  }
}
